import { isEmpty } from 'lodash';
import { GroupOfSelectedDays } from '../types/Deal.types';
import { DAYS_IN_TWO_WEEKS, DAYS_IN_WEEK, LAST_DAY_INDEX, UPPERCASE_DAYS_OF_THE_WEEK } from './constants';
import { PatternOption } from './DaypartTargeting.types';
import { Days } from '../types/DirectSalesCampaign.types';

export const hasDaypartTargeting = (
  selectedDays: GroupOfSelectedDays | undefined = {},
  patternRepeatType: PatternOption,
  dateRangeLength: number,
): boolean => {
  if (isEmpty(selectedDays)) return false;

  const savedLength = Object.keys(selectedDays).length;

  const repeatPattern = {
    [PatternOption.NO_REPEAT]: 0,
    [PatternOption.REPEAT_ONE_WEEK]: DAYS_IN_WEEK,
    [PatternOption.REPEAT_TWO_WEEKS]: DAYS_IN_TWO_WEEKS,
  };

  const isNoRepeatIncorrect = dateRangeLength !== savedLength && patternRepeatType === PatternOption.NO_REPEAT;

  const isLengthIncorrect = repeatPattern[patternRepeatType] % savedLength !== 0;

  const someDayIsNotFullDay = Object.values(selectedDays).some(({ isFullDay }) => !isFullDay);

  return isNoRepeatIncorrect || isLengthIncorrect || someDayIsNotFullDay;
};

export const getStartDayId = (startDate: Date | string): number => {
  return (new Date(startDate).getDay() + LAST_DAY_INDEX) % DAYS_IN_WEEK;
};

export const isAllSelectedFullDays = (selectedDays: GroupOfSelectedDays = {}): boolean =>
  selectedDays && Object.values(selectedDays).every(({ isFullDay }) => isFullDay);

export const getDayOfTheWeekByIndex = (dayId: number): Days => {
  const weekIndex = dayId % DAYS_IN_WEEK;
  return UPPERCASE_DAYS_OF_THE_WEEK[weekIndex < 6 ? weekIndex + 1 : 0] as Days;
};

export const getDayOfTheWeekByDate = (date: Date): Days => {
  return UPPERCASE_DAYS_OF_THE_WEEK[date.getDay()] as Days;
};
